document.addEventListener('DOMContentLoaded', function() {
    var leftRevie = document.getElementById('leftRevie');
    leftRevie.setAttribute('disabled', '');
    let revieBtn = document.querySelectorAll('#leftRevie, #rightRevie');
    const itemsRevie = document.querySelectorAll('#revieListCarousel .itemsC');
    
    const observerRevie = new IntersectionObserver((entries) => {
        let visibleIndexes = [];
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const index = Array.from(itemsRevie).indexOf(entry.target);
                visibleIndexes.push(index);
            }
        });
        if (visibleIndexes.length) {
            const minIndex = Math.min(...visibleIndexes);
            const maxIndex = Math.max(...visibleIndexes);

            revieBtn[0].disabled = minIndex === 0;
            revieBtn[1].disabled = maxIndex === itemsRevie.length - 1;
        }
        }, {
        threshold: 0.9
    });
    
    itemsRevie.forEach((item) => {
        observerRevie.observe(item);
    })
});